export default [
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'T-OBST-01',
        data: [
            {
                "cross_section": "42157",
                "data": [
                    {
                        "cross_section": "42157",
                        "base_start_sta": null,
                        "base_end_sta": null,
                        "base_elev": null,
                        "cmp_start_sta": 5400,
                        "cmp_end_sta": 5800,
                        "cmp_elev": 160
                    }
                ]
            }
        ]
    }
]